const BOXCAST_URL_REGEXP = /boxcast\.com/;
angular.module('app.directives').directive('notBoxcast', () => {
  'ngInject';

  return {
    require: 'ngModel',
    link: (scope, elm, attrs, ctrl) => {
      ctrl.$validators.notBoxcast = (modelValue, viewValue) => {
        if (ctrl.$isEmpty(modelValue)) {
          // consider empty models to be valid
          return true;
        }
        return !BOXCAST_URL_REGEXP.test(viewValue);
      };
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/not-boxcast.js